import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e1761e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "avatar"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "z-avatar__wrap z-avatar__actions" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-avatar__text" }, "重新上传", -1))
const _hoisted_5 = { class: "z-avatar__delete" }
const _hoisted_6 = {
  key: 1,
  class: "z-avatar__wrap"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-avatar__text" }, "上传头像", -1))

import { ref, getCurrentInstance, ComponentInternalInstance, reactive, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { Plus, CloseBold, FolderAdd } from '@element-plus/icons-vue'
import { util } from '@/utils/util.js'
import cryptojs from '@/utils/sha1.js'
import type { UploadFile, ElUploadProgressEvent, ElFile } from 'element-plus/es/components/upload/src/upload.type'


export default /*#__PURE__*/_defineComponent({
  props: { fileUrl: String },
  emits: ['successUpload'],
  setup(__props, { emit }) {

const props = __props

const { proxy }: { proxy: any } = getCurrentInstance() as ComponentInternalInstance




const imageUrl = ref('')

let uploads = reactive({
  file: null
})

watch(props, (newValue, oldValue) => {
  imageUrl.value = newValue.fileUrl
})

const beforeUpload = (file: ElFile) => {
  const isImage = ['bmp', 'jpg', 'jpeg', 'png', 'gif', 'svg', 'JPG', 'JPEG', 'PNG', 'SVG', 'GIF', 'BMP'].includes(
    (file.name as any).split('.').pop()
  )
  const isLt2M = file.size / 1024 / 1024 < 2

  if (!isImage) {
    ElMessage.error('头像只能上传图片！')
  }
  if (!isLt2M) {
    ElMessage.error('头像不能超过2MB！')
  }
  return isImage && isLt2M
}

// 移除文件
const handleRemove = (file: ElFile) => {
  imageUrl.value = ''
  emit('successUpload', '', null)
}

// 首次上传文件
const getUploadToken = (file: UploadFile) => {
  getToken(file.file)
}

// N次上传文件
const handleExceed = (files) => {
  beforeUpload(files[0]) && getToken(files[0])
}

// 获取Token
const getToken = (file: UploadFile) => {
  proxy.$http.resume.getToken().then((res: any) => {
    let time = new Date().getTime()
    let nonce = cryptojs.sha1(time).toString()
    let timestamp = Number(time / 1000)

    uploads = {
      upload_token: res.uploadToken,
      group: 'private',
      appid: res.appId,
      nonce: nonce,
      signature: cryptojs.sha1([nonce, timestamp, res.uploadToken].sort().join('')).toString().toUpperCase(),
      timestamp: timestamp,
      file: file,
      ext: file.name.substring(file.name.lastIndexOf('.') + 1)
    }
    uploadFile()
  })
}

// 上传文件到文件服务器
const uploadFile = () => {
  let formData = new FormData()
  formData.append('appid', uploads.appid)
  formData.append('upload_token', uploads.upload_token)
  formData.append('group', `private`)
  formData.append('timestamp', uploads.timestamp)
  formData.append('nonce', uploads.nonce)
  formData.append('filename', util.guid())
  formData.append('signature', uploads.signature)
  formData.append('ext', uploads.ext)
  formData.append('uploadfile', uploads.file)
  proxy.$http.resume.uploadEncryptFile(formData).then((res: any) => {
    proxy.$http.resume
      .getFile({
        attachmentName: res.fileName
      })
      .then((fileRes) => {
        imageUrl.value = `${fileRes}`
        emit('successUpload', fileRes, res.fileName)
      })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createBlock(_component_el_upload, {
    class: "z-avatar",
    action: "",
    "show-file-list": false,
    "before-upload": beforeUpload,
    "http-request": getUploadToken,
    limit: 1,
    "on-exceed": handleExceed
  }, {
    default: _withCtx(() => [
      (imageUrl.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", { src: imageUrl.value }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_icon, { class: "z-avatar__icon" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FolderAdd))
                ]),
                _: 1
              }),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_icon, {
                onClick: _withModifiers(handleRemove, ["stop"])
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CloseBold))
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_icon, { class: "z-avatar-icon" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus))
              ]),
              _: 1
            }),
            _hoisted_7
          ]))
    ]),
    _: 1
  }))
}
}

})